var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1784.35 1834.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daf1fa;}.cls-2{fill:#fff;}.cls-3{fill:#2a89b2;}.cls-4{fill:#5caed1;}.cls-5{fill:#b3e3f4;}.cls-6{fill:#add6e8;}.cls-7{fill:#99b9ff;}.cls-8{fill:#d9f1f9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M987.06,1315.32c61.36-287.41,562.06-344.25,640-240.53,29.16,38.84-9.35,89,29.62,142.87,24.3,33.6,61.06,44.23,99.45,48.71a577.73,577.73,0,0,0,25.31-119.6c3.48-34.31,18.06-210.1-74.42-372.51-11.66,3.73-21.06,6.39-27.53,8.15-245.89,66.63-499.33-36.08-626.88-190.74-32.36-39.24-83-100.63-80.25-181,3.34-97.87,82.73-132.08,186.22-279.39-15.7-26.12-36.06-49.78-67.17-71.57C963.88-29.55,764.74-11.08,581.48,64.6,680.19,154,740.2,289.87,717,429c-42.11,252.58-338.41,394.71-555.33,307.6-45.1-18.11-85.9-45.79-120.62-80.28-49,161.29-56.86,339.26-8.86,513.1,50-102.53,199.24-191.93,344.21-180.56,109.28,8.57,182.22,71.76,212.15,98.38,17.84,15.88,145.39,133.15,140.24,314.18-4.34,152.75-100.92,271.57-210.36,341.85,168.8,80.48,358.94,109.9,539,80.4,69.48-11.38,138.72-31.75,205.32-59.73C1082.19,1692,950.27,1487.62,987.06,1315.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.65,
    y: 21.88,
    width: 396.49,
    height: 538.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M528.14,567.4H131.65a7.09,7.09,0,0,1-7.1-7.09V21.89a7.1,7.1,0,0,1,7.1-7.1H528.14a7.09,7.09,0,0,1,7.09,7.1V560.31A7.08,7.08,0,0,1,528.14,567.4Zm-389.4-14.19H521V29H138.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 194.36,
    y: 87.82,
    width: 271.06,
    height: 83.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 199.09,
    y: 246.87,
    width: 88.8,
    height: 83.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.89,337.31h-88.8a7.08,7.08,0,0,1-7.09-7.09V246.87a7.09,7.09,0,0,1,7.09-7.1h88.8a7.1,7.1,0,0,1,7.1,7.1v83.35A7.09,7.09,0,0,1,287.89,337.31Zm-81.7-14.19H280.8V254H206.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 364.64,
    y: 246.87,
    width: 88.8,
    height: 83.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.44,337.31h-88.8a7.09,7.09,0,0,1-7.1-7.09V246.87a7.1,7.1,0,0,1,7.1-7.1h88.8a7.09,7.09,0,0,1,7.09,7.1v83.35A7.08,7.08,0,0,1,453.44,337.31Zm-81.71-14.19h74.61V254H371.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 199.09,
    y: 407.69,
    width: 88.8,
    height: 83.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.89,498.13h-88.8A7.09,7.09,0,0,1,192,491V407.69a7.09,7.09,0,0,1,7.09-7.1h88.8a7.1,7.1,0,0,1,7.1,7.1V491A7.1,7.1,0,0,1,287.89,498.13Zm-81.7-14.19H280.8V414.78H206.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 364.64,
    y: 407.69,
    width: 88.8,
    height: 83.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.44,498.13h-88.8a7.1,7.1,0,0,1-7.1-7.09V407.69a7.1,7.1,0,0,1,7.1-7.1h88.8a7.09,7.09,0,0,1,7.09,7.1V491A7.09,7.09,0,0,1,453.44,498.13Zm-81.71-14.19h74.61V414.78H371.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1161.24,
    y: 237.48,
    width: 395.92,
    height: 397.3,
    rx: 13.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1528.33,639.23H1190.07A33.32,33.32,0,0,1,1156.79,606V266.31A33.32,33.32,0,0,1,1190.07,233h338.26a33.32,33.32,0,0,1,33.28,33.28V606A33.32,33.32,0,0,1,1528.33,639.23ZM1190.07,241.94a24.4,24.4,0,0,0-24.38,24.37V606a24.41,24.41,0,0,0,24.38,24.38h338.26A24.4,24.4,0,0,0,1552.7,606V266.31a24.39,24.39,0,0,0-24.37-24.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1213.05,500.57a4.45,4.45,0,0,1-1.82-8.52c136.14-60.91,240.57-146.82,292.9-206.91a4.45,4.45,0,0,1,6.72,5.85c-53,60.8-158.52,147.69-296,209.19A4.47,4.47,0,0,1,1213.05,500.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1510.22,316.42h0a4.45,4.45,0,0,1-4.4-4.5l.28-24.61-26.06-.8a4.46,4.46,0,0,1-4.32-4.59,4.37,4.37,0,0,1,4.59-4.31l30.43.94a4.46,4.46,0,0,1,4.32,4.5l-.34,29A4.45,4.45,0,0,1,1510.22,316.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1209.98,
    y: 540.25,
    width: 41.61,
    height: 52.83,
    rx: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1296.66,
    y: 493.47,
    width: 41.61,
    height: 99.6,
    rx: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1383.35,
    y: 443.35,
    width: 41.61,
    height: 149.73,
    rx: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1470.03,
    y: 378.61,
    width: 41.61,
    height: 214.47,
    rx: 7.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1335.39,210.31a4.45,4.45,0,0,0-4.06-3.8l-30.11-2.44a4.44,4.44,0,0,1-3.83-3,135.64,135.64,0,0,0-6.87-16.13,4.41,4.41,0,0,1,.51-4.78l19.1-23.24a4.42,4.42,0,0,0,.06-5.54l-16.31-20.7a4.48,4.48,0,0,0-5.43-1.27l-27.32,12.86a4.46,4.46,0,0,1-4.79-.66,141.06,141.06,0,0,0-14.07-10.52,4.4,4.4,0,0,1-2-4.39l4.86-29.67a4.43,4.43,0,0,0-2.74-4.82l-24.53-9.83a4.48,4.48,0,0,0-5.34,1.6l-17.17,24.67a4.44,4.44,0,0,1-4.48,1.81,140.53,140.53,0,0,0-17.5-2.08,4.45,4.45,0,0,1-3.93-2.83l-10.71-28.09a4.48,4.48,0,0,0-4.8-2.82l-26.19,3.69a4.45,4.45,0,0,0-3.82,4l-2.46,29.94a4.41,4.41,0,0,1-3,3.8,138.74,138.74,0,0,0-16.24,6.83,4.48,4.48,0,0,1-4.81-.5l-23.37-19a4.48,4.48,0,0,0-5.58-.06l-20.83,16.21a4.41,4.41,0,0,0-1.28,5.38l12.94,27.17a4.4,4.4,0,0,1-.66,4.76,139.57,139.57,0,0,0-10.59,14,4.45,4.45,0,0,1-4.42,1.95l-29.84-4.82a4.48,4.48,0,0,0-4.86,2.72l-9.89,24.39a4.42,4.42,0,0,0,1.6,5.31l24.83,17.06a4.39,4.39,0,0,1,1.82,4.44,135.69,135.69,0,0,0-2.1,17.41,4.43,4.43,0,0,1-2.85,3.9L994.12,254a4.43,4.43,0,0,0-2.84,4.77l3.71,26a4.46,4.46,0,0,0,4.06,3.8l30.11,2.44a4.45,4.45,0,0,1,3.83,3,135.09,135.09,0,0,0,6.87,16.14,4.41,4.41,0,0,1-.51,4.78l-19.1,23.24a4.41,4.41,0,0,0-.06,5.53l16.31,20.71a4.48,4.48,0,0,0,5.43,1.27l27.32-12.86a4.44,4.44,0,0,1,4.79.66,142.63,142.63,0,0,0,14.07,10.52,4.4,4.4,0,0,1,2,4.39L1085.22,398a4.43,4.43,0,0,0,2.74,4.82l24.53,9.83a4.48,4.48,0,0,0,5.34-1.6L1135,386.38a4.44,4.44,0,0,1,4.48-1.81,140.53,140.53,0,0,0,17.5,2.08,4.45,4.45,0,0,1,3.93,2.83l10.71,28.08a4.47,4.47,0,0,0,4.8,2.82l26.19-3.68a4.45,4.45,0,0,0,3.82-4l2.46-29.94a4.41,4.41,0,0,1,3-3.8,138.74,138.74,0,0,0,16.24-6.83,4.46,4.46,0,0,1,4.81.5l23.37,19a4.48,4.48,0,0,0,5.58.06l20.83-16.21A4.42,4.42,0,0,0,1284,370L1271,342.87a4.4,4.4,0,0,1,.66-4.76,139.57,139.57,0,0,0,10.59-14,4.45,4.45,0,0,1,4.42-1.95l29.84,4.82a4.48,4.48,0,0,0,4.86-2.72l9.89-24.39a4.42,4.42,0,0,0-1.6-5.31l-24.83-17.06a4.4,4.4,0,0,1-1.82-4.45,135.32,135.32,0,0,0,2.1-17.4,4.41,4.41,0,0,1,2.85-3.9l28.26-10.65a4.43,4.43,0,0,0,2.84-4.77Zm-170.2,125.11c-48.87,0-88.48-39.35-88.48-87.89s39.61-87.89,88.48-87.89,88.48,39.35,88.48,87.89S1214.06,335.42,1165.19,335.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1175.77,424.88a8.86,8.86,0,0,1-8.31-5.73l-10.71-28.09a139.28,139.28,0,0,1-18.08-2.11l-17.18,24.65a8.91,8.91,0,0,1-10.66,3.18L1086.3,407a8.82,8.82,0,0,1-5.47-9.67l4.85-29.67a137.85,137.85,0,0,1-14.52-10.79l-27.34,12.83A8.89,8.89,0,0,1,1033,367.1l-16.3-20.7a8.8,8.8,0,0,1,.11-11.11l19.1-23.25a133.3,133.3,0,0,1-7.12-16.6L998.69,293a8.86,8.86,0,0,1-8.11-7.61l-3.7-26a8.82,8.82,0,0,1,5.68-9.56l28.25-10.65a137.92,137.92,0,0,1,2.14-17.95l-24.79-17A8.83,8.83,0,0,1,995,193.51l9.89-24.39a8.86,8.86,0,0,1,9.7-5.44l29.84,4.82A142.28,142.28,0,0,1,1055.3,154l-12.92-27.1a8.82,8.82,0,0,1,2.57-10.82l20.83-16.2a8.88,8.88,0,0,1,11.12.11l23.37,19a141.33,141.33,0,0,1,16.77-7.07L1119.51,82a8.85,8.85,0,0,1,7.64-8.07l26.19-3.68a8.87,8.87,0,0,1,9.58,5.64L1173.63,104a140.83,140.83,0,0,1,18.08,2.12l17.18-24.65a8.88,8.88,0,0,1,10.65-3.18l24.54,9.82a8.84,8.84,0,0,1,5.47,9.68l-4.85,29.67a137.85,137.85,0,0,1,14.52,10.79l27.34-12.83a8.87,8.87,0,0,1,10.82,2.55l16.3,20.7a8.81,8.81,0,0,1-.11,11.12L1294.47,183a132.45,132.45,0,0,1,7.12,16.6l30.1,2.45a8.86,8.86,0,0,1,8.11,7.61h0l3.7,26a8.84,8.84,0,0,1-5.67,9.56l-28.26,10.65a137.71,137.71,0,0,1-2.14,17.95l24.79,17a8.83,8.83,0,0,1,3.21,10.65l-9.89,24.39a8.84,8.84,0,0,1-9.7,5.44L1286,326.56A141.79,141.79,0,0,1,1275.08,341L1288,368.12a8.83,8.83,0,0,1-2.57,10.82l-20.83,16.2a8.9,8.9,0,0,1-11.12-.11l-23.37-19a140.63,140.63,0,0,1-16.77,7.07L1210.87,413a8.85,8.85,0,0,1-7.65,8.07L1177,424.79A9.15,9.15,0,0,1,1175.77,424.88ZM1138.66,380a9.07,9.07,0,0,1,1.63.15,136.08,136.08,0,0,0,16.94,2,8.92,8.92,0,0,1,7.84,5.69L1175.78,416l26.21-3.69,2.46-29.93a8.89,8.89,0,0,1,6-7.63,136.91,136.91,0,0,0,15.71-6.62,9,9,0,0,1,9.6,1l23.37,19L1280,371.91l-13-27.13a8.84,8.84,0,0,1,1.31-9.57,135.67,135.67,0,0,0,10.25-13.55,9,9,0,0,1,8.84-3.89l29.84,4.82,9.91-24.39-24.82-17a8.85,8.85,0,0,1-3.67-8.93,134.71,134.71,0,0,0,2-16.84,8.89,8.89,0,0,1,5.72-7.81L1334.69,237l-3.7-26-30.13-2.44a8.9,8.9,0,0,1-7.66-5.92,133.44,133.44,0,0,0-6.65-15.62,8.86,8.86,0,0,1,1-9.6l19.1-23.25-16.3-20.65L1263,146.33a9,9,0,0,1-9.58-1.3,135.87,135.87,0,0,0-13.62-10.18,8.86,8.86,0,0,1-3.92-8.84l4.86-29.67-24.54-9.79L1199,111.23a9,9,0,0,1-9,3.64,136.08,136.08,0,0,0-16.94-2,8.94,8.94,0,0,1-7.84-5.69L1154.6,79.08l-26.21,3.69-2.46,29.93a8.89,8.89,0,0,1-6,7.63,136.32,136.32,0,0,0-15.72,6.62,8.94,8.94,0,0,1-9.6-1l-23.37-19-20.87,16.21,12.94,27.12a8.85,8.85,0,0,1-1.31,9.58,136.42,136.42,0,0,0-10.25,13.55,8.93,8.93,0,0,1-8.84,3.89l-29.84-4.82-9.91,24.39,24.82,17a8.84,8.84,0,0,1,3.67,8.93,134.94,134.94,0,0,0-2,16.84,8.87,8.87,0,0,1-5.72,7.81l-28.26,10.65,3.7,26,30.13,2.43a8.91,8.91,0,0,1,7.66,5.92,134.42,134.42,0,0,0,6.65,15.62,8.84,8.84,0,0,1-1,9.6l-19.1,23.24,16.3,20.66,27.36-12.86a9,9,0,0,1,9.58,1.3,136.26,136.26,0,0,0,13.62,10.18,8.88,8.88,0,0,1,3.92,8.83l-4.85,29.68,24.53,9.79,17.19-24.68A8.93,8.93,0,0,1,1138.66,380ZM1331,210.94Zm-165.8,128.93c-51.24,0-92.94-41.43-92.94-92.34s41.7-92.34,92.94-92.34,92.94,41.42,92.94,92.34S1216.43,339.87,1165.19,339.87Zm0-175.78c-46.33,0-84,37.43-84,83.44s37.7,83.44,84,83.44,84-37.43,84-83.44S1211.53,164.09,1165.19,164.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.24,1579.91H586.42v-23.77H570.07l0-99,16.31-.11,1.06-26.35H163.3c-18.47,0-46.56,29.64-46.56,49.73v54.26C116.74,1554.75,143.77,1579.91,162.24,1579.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.13,1457.1H558a13.61,13.61,0,0,1,13.61,13.61v71.79A13.61,13.61,0,0,1,558,1556.11H141.13a0,0,0,0,1,0,0v-99A0,0,0,0,1,141.13,1457.1Z",
    transform: "translate(712.72 3013.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.59,1560H171.15a33.94,33.94,0,0,1-33.9-33.9v-39a33.94,33.94,0,0,1,33.9-33.9H571.59a3.88,3.88,0,0,1,3.88,3.88v99A3.88,3.88,0,0,1,571.59,1560Zm-400.44-99A26.17,26.17,0,0,0,145,1487.12v39a26.17,26.17,0,0,0,26.14,26.14H567.71V1461Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.64,1491.83H185.54a3.89,3.89,0,0,1,0-7.77h365.1a3.89,3.89,0,0,1,0,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M439.2,1522.67H185.54a3.88,3.88,0,0,1,0-7.76H439.2a3.88,3.88,0,0,1,0,7.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "305.32 1236.42 251.98 1250.7 180.11 985.59 233.45 971.31 305.32 1236.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.25,1255.45l-73.9-272.61,60.83-16.28,73.91,272.61ZM184.88,988.33,254.72,1246l45.84-12.27L230.72,976.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.76,1015.2a3.88,3.88,0,0,1-1-7.63l23.55-6.16a3.88,3.88,0,1,1,2,7.51l-23.55,6.16A4.17,4.17,0,0,1,203.76,1015.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.47,1288.67c-33.65-.43-64.57-29.32-64.57-64.91s30.92-64.47,64.57-64.91v-34.33c-49.17.44-99.13,44.69-99.13,99.24s50,98.81,99.13,99.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.89,1326.84h-.14c-47.57-1.72-100.58-44.47-100.58-103.07s54.36-102.69,103-103.12a4.17,4.17,0,0,1,2.77,1.12,3.9,3.9,0,0,1,1.14,2.76v34.33a3.87,3.87,0,0,1-3.83,3.88c-32.35.42-60.73,28.94-60.73,61,0,31.91,27.22,59.84,59.44,61a3.89,3.89,0,0,1,3.74,4,3.84,3.84,0,0,1-4,3.74c-36.27-1.31-66.92-32.79-66.92-68.76,0-35.53,29.19-66.12,64.56-68.63v-26.59c-43.93,2.64-91.36,42.69-91.36,95.22,0,54.18,49.07,93.72,93.1,95.32a3.88,3.88,0,0,1-.14,7.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "303.74 1176.36 222.3 1198.16 189.42 1076.94 270.86 1055.14 303.74 1176.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.57,1202.91,184.65,1074.2l88.94-23.81,34.92,128.71Zm-25.38-123.23L225,1193.4,299,1173.62l-30.84-113.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.87,
    y: 1323.43,
    width: 62.86,
    height: 70.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.73,1397.9H260.24a3.89,3.89,0,0,1,0-7.77h17.61v-62.82h-55.1v62.82h2.69a3.89,3.89,0,0,1,0,7.77h-6.57A3.88,3.88,0,0,1,215,1394v-70.59a3.88,3.88,0,0,1,3.88-3.88h62.86a3.88,3.88,0,0,1,3.88,3.88V1394A3.88,3.88,0,0,1,281.73,1397.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.87,
    y: 1288.64,
    width: 142.49,
    height: 33.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.36,1326.84H218.87a3.89,3.89,0,0,1,0-7.77H357.48v-26.55H222.75v11.57a3.88,3.88,0,1,1-7.76,0v-15.45a3.88,3.88,0,0,1,3.88-3.88H361.36a3.88,3.88,0,0,1,3.88,3.88V1323A3.89,3.89,0,0,1,361.36,1326.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 169.29,
    y: 1394.04,
    width: 166.75,
    height: 33.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336,1431.48H169.29a3.88,3.88,0,0,1-3.88-3.88V1394a3.88,3.88,0,0,1,3.88-3.88h62.3a3.88,3.88,0,0,1,0,7.76H173.17v25.79h159v-25.79h-75.9a3.88,3.88,0,0,1,0-7.76H336a3.88,3.88,0,0,1,3.88,3.88v33.56A3.88,3.88,0,0,1,336,1431.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.68,1393.43,467,1327.35v-94.46H407.5v94.46L362,1393.43c-10,14.69.62,34.82,18.46,34.82h113.8C512.06,1428.25,522.66,1408.12,512.68,1393.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M494.22,1432.13H380.42a26.24,26.24,0,0,1-21.67-40.88l44.87-65.11V1229H470.9v97.13l45,65.11a26.24,26.24,0,0,1-21.68,40.88Zm-82.84-195.36v91.79l-46.23,67.07a18.49,18.49,0,0,0,15.27,28.74h113.8a18.48,18.48,0,0,0,15.26-28.75l-46.34-67.06v-91.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M441.14,1315.17a3.88,3.88,0,0,1-3.88-3.88V1265a3.88,3.88,0,0,1,7.76,0v46.27A3.88,3.88,0,0,1,441.14,1315.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.12,1622.46h241a16.47,16.47,0,0,0,15.9-14.19l40-331.68c1-7.83-3.34-17.88-15.92-17.88l-237.58,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590.15,1626.46h-241a4,4,0,0,1-4-4.48l43.49-360.06a4,4,0,0,1,3.9-3.51l237.58-3.7c8,0,12.68,3.41,15.21,6.26a20.81,20.81,0,0,1,4.74,16.1L1610,1608.75C1608.83,1618.51,1599.92,1626.46,1590.15,1626.46Zm-236.52-8h236.52a12.55,12.55,0,0,0,11.93-10.68l40.06-331.68a12.86,12.86,0,0,0-2.79-9.84c-2.1-2.37-5.18-3.57-9.17-3.57l-234,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.9,1622.46h227l43.49-360.06h-227a16.46,16.46,0,0,0-15.9,14.19l-40.06,331.68A12.31,12.31,0,0,0,1121.9,1622.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.9,1626.46h-227a16.39,16.39,0,0,1-12.49-5.47,16.62,16.62,0,0,1-4-13.2l40.06-331.68a20.58,20.58,0,0,1,19.87-17.7h227a4,4,0,0,1,4,4.47l-43.48,360.06A4,4,0,0,1,1348.9,1626.46ZM1165.38,1266.4a12.56,12.56,0,0,0-11.94,10.67l-40,331.68a8.63,8.63,0,0,0,2,6.94,8.51,8.51,0,0,0,6.51,2.78h223.46l42.52-352.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1345.67,1618.76h241a16.47,16.47,0,0,0,15.9-14.18l40.06-331.69a12.32,12.32,0,0,0-12.48-14.18h-241Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.7,1622.76h-241a4,4,0,0,1-4-4.47l43.48-360.06a4,4,0,0,1,4-3.52h241a16.42,16.42,0,0,1,12.49,5.46,16.59,16.59,0,0,1,3.95,13.2l-40,331.68C1605.39,1614.82,1596.48,1622.76,1586.7,1622.76Zm-236.52-8H1586.7a12.56,12.56,0,0,0,11.94-10.67l40-331.68a8.71,8.71,0,0,0-2-6.94,8.52,8.52,0,0,0-6.51-2.78H1392.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1113.17,1618.76h231.44l44.33-360H1157.5a16.67,16.67,0,0,0-16.21,14.18l-40.84,331.69C1099.49,1612.41,1105.18,1618.76,1113.17,1618.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.61,1622.76H1113.17a16.75,16.75,0,0,1-12.76-5.56,16.45,16.45,0,0,1-3.92-13.11l40.84-331.68c1.2-9.76,10.25-17.7,20.17-17.7h231.44a4,4,0,0,1,4,4.48l-44.33,360.06A4,4,0,0,1,1344.61,1622.76ZM1157.5,1262.7a12.75,12.75,0,0,0-12.24,10.68l-40.84,331.68a8.58,8.58,0,0,0,2,6.84,8.88,8.88,0,0,0,6.78,2.87h227.91l43.34-352.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1587.82,1612.55H1346.69a4,4,0,0,1-3.19-6.4l34.46-45.58a4,4,0,0,1,3-1.59l181.07-6.55a4.14,4.14,0,0,1,1.77.34l26.4,11.74a4,4,0,0,1,2.37,3.73l-.79,40.39A4,4,0,0,1,1587.82,1612.55Zm-233.1-8H1583.9l.67-33.83-23.13-10.28-178.25,6.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1626.5 1220.57 1631.17 1249.62 1587.82 1608.55 1583.02 1580.63 1626.5 1220.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1587.82,1612.55a4,4,0,0,1-3.94-3.32l-4.8-27.92a3.76,3.76,0,0,1,0-1.16l43.48-360.06a4,4,0,0,1,7.91-.15l4.68,29a4.58,4.58,0,0,1,0,1.11L1591.79,1609a4,4,0,0,1-3.87,3.52Zm-.77-32,.08.45,40-331.29-.08-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.8,1608.55h0c17.37-17.72,40.81-27.92,64.18-27.92h172l43.48-360.06h-172c-23.37,0-46.81,10.2-64.18,27.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1372.34,1568.27a108.17,108.17,0,0,1,41.14-8.32h151.35l38.49-318.69H1452c-15,0-29.9,5.6-42,15.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.81,1604.22l-.48,0a4,4,0,0,1-3.49-4.44L1386.31,1248a4,4,0,0,1,1.12-2.32c18.14-18.51,42.57-29.12,67-29.12h172a4,4,0,0,1,4,4.47L1587,1581.11a4,4,0,0,1-4,3.52h-24.55a4,4,0,0,1,0-8h21L1622,1224.57H1454.46c-21.91,0-43.84,9.37-60.38,25.77l-42.31,350.37A4,4,0,0,1,1347.81,1604.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.69,1612.55H1122a4,4,0,0,1-3.94-3.32l-4.8-27.92a4.06,4.06,0,0,1,.22-2.15l110-278.48a4,4,0,0,1,3.72-2.53h0a4,4,0,0,1,3.71,2.54l119.5,306.41a4,4,0,0,1-3.72,5.45Zm-221.3-8h215.45l-113.67-291.48-105.83,268Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.69,1608.55h0c-13.09-17.72-34.07-27.92-57.44-27.92h-172l43.48-360.06h172c23.38,0,44.35,10.2,57.44,27.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1368.48,1256.82c-9.69-10-23.29-15.56-38.24-15.56H1178.88L1140.39,1560h151.36a93.74,93.74,0,0,1,39.12,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.64,1579.91a4,4,0,0,1-.49,0,4,4,0,0,1-3.48-4.44L1386,1249.62c-12.39-15.94-31.72-25-53.27-25h-168.5l-41.87,350.49a4,4,0,0,1-7.94-1l42.3-354a4,4,0,0,1,4-3.52h172c24.67,0,46.78,10.77,60.65,29.54a4,4,0,0,1,.75,2.85L1354.6,1576.4A4,4,0,0,1,1350.64,1579.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1432.9,
    y: 1349.1,
    width: 135.91,
    height: 10.34,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1407.05,
    y: 1325.46,
    width: 135.91,
    height: 10.34,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1402.62,
    y: 1372,
    width: 135.91,
    height: 10.34,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1427.73,
    y: 1394.16,
    width: 135.91,
    height: 10.34,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1206.88,
    y: 1289.27,
    width: 125.31,
    height: 10.34,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1189.39,
    y: 1312.17,
    width: 123.12,
    height: 10.34,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1177.57,
    y: 1334.33,
    width: 149.21,
    height: 10.34,
    rx: 4.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.5e2df2c536945b97fb4173d6674ecc14.svg";
export { ForwardRef as ReactComponent };